const dialog = document.getElementById('dialog')
const body = document.body

const showDialog = () => {
  const scrollY = window.scrollY + 'px'
  body.style.position = 'fixed'
  body.style.top = `-${scrollY}`
  dialog.classList.add('show')
}
const closeDialog = (target) => {
  const text = target.innerText
  const scrollY = body.style.top
  body.style.position = ''
  body.style.top = ''
  window.scrollTo(0, parseInt(scrollY || '0') * -1)

  if (target.type === 'submit') {
    target.innerText = '...Loading'
    setTimeout(() => {
      dialog.classList.remove('show')
    }, 500)

    setTimeout(() => {
      target.innerText = text
    }, 1000)
  } else {
    dialog.classList.remove('show')
  }
}

const showDialogButton = document.getElementById('showDialog')
if (showDialogButton) {
  const closeDialogButtons = Array.from(document.getElementsByClassName('mobileDialogClose'))

  showDialogButton.addEventListener('click', () => {
    showDialog()
  })
  closeDialogButtons.forEach((e) => {
    e.addEventListener('click', (event) => {
      closeDialog(event.target)
    })
  })
}
